import { useRoute } from '@react-navigation/native'
import { FlashList } from '@shopify/flash-list'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'
import { EligibilityCard } from '@zet/feature-brands/components/eligibilityCard'
import { i18n } from '@zet/localization'

import useVariantDetails from '../../hooks/useVariantDetails'

export const EligibilityCriteria = ({
  partnerId,
  variantId,
}: {
  partnerId: string | number
  variantId?: string | number
}) => {
  const { params } = useRoute()
  const brandId = params?.brandId || partnerId
  const _variantId = params?.variantId || variantId
  const { data: content } = useBrandDetailsById(brandId || '')
  const { data: variantData } = useVariantDetails({
    variantId: _variantId,
  })

  const salaried = content?.eligibilityCriteria?.salaried
  const selfEmployed = content?.eligibilityCriteria?.selfEmployed

  const salariedIncomeRange =
    variantData?.salaryRangeIncomeCriteria?.salaried?.text ||
    content?.eligibilityCriteria?.salaried?.incomeRange ||
    ''

  const selfEmpIncomeRange =
    variantData?.salaryRangeIncomeCriteria?.selfEmployed?.text ||
    content?.eligibilityCriteria?.selfEmployed?.incomeRange ||
    ''

  const data = [
    {
      id: 'index-1',
      type: 'salaried',
      ageGroup: salaried?.ageGroup,
      incomeRange: salariedIncomeRange,
      documentsRequired: [
        {
          heading: i18n.t('eligibilityCriteria.identityProof'),
          content: salaried?.documentsRequired?.identityProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.addressProof'),
          content: salaried?.documentsRequired?.addressProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.incomeProof'),
          content: salaried?.documentsRequired?.incomeProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.other'),
          content: salaried?.documentsRequired?.Other,
        },
      ],
    },
    {
      id: 'index-2',
      type: 'selfEmployed',
      ageGroup: selfEmployed?.ageGroup,
      incomeRange: selfEmpIncomeRange,
      documentsRequired: [
        {
          heading: i18n.t('eligibilityCriteria.identityProof'),
          content: selfEmployed?.documentsRequired?.identityProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.addressProof'),
          content: selfEmployed?.documentsRequired?.addressProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.incomeProof'),
          content: selfEmployed?.documentsRequired?.incomeProof,
        },
        {
          heading: i18n.t('eligibilityCriteria.other'),
          content: selfEmployed?.documentsRequired?.Other,
        },
      ],
    },
  ]

  return (
    <FlashList
      bounces={false}
      showsVerticalScrollIndicator={false}
      data={data}
      estimatedItemSize={5}
      renderItem={({ item }) => EligibilityCard(item)}
      keyExtractor={(item) => item.id}
    />
  )
}
